/* NCERT Wala — small progressive-enhancement script. Every feature works without it. */
(function () {
  'use strict';

  /* ---------- Cart count + toast ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  var toastTimer;
  function showToast(message, linkHref, linkText, isError) {
    var toast = document.querySelector('[data-toast]');
    if (!toast) return;
    toast.textContent = '';
    toast.classList.toggle('toast--error', !!isError);
    var span = document.createElement('span');
    span.textContent = message;
    toast.appendChild(span);
    if (linkHref) {
      var a = document.createElement('a');
      a.href = linkHref;
      a.textContent = linkText;
      toast.appendChild(a);
    }
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, isError ? 8000 : 7000);
  }

  function rootUrl(path) {
    return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + path;
  }


  /* ---------- Add to cart without leaving the page ---------- */
  function initProductForms() {
    // Remember which button submitted the form (older Safari has no event.submitter).
    var lastSubmitter = null;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-product-form] button[type="submit"]');
      if (btn) lastSubmitter = btn;
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('[data-product-form]')) return;

      // "Buy Now" posts normally so Shopify adds the book and goes straight to checkout.
      var submitter = event.submitter || (lastSubmitter && form.contains(lastSubmitter) ? lastSubmitter : null);
      lastSubmitter = null;
      if (submitter && submitter.name === 'return_to') return;
      if (!window.fetch) return;

      event.preventDefault();
      // One request at a time per form, so double-clicks can't add the book twice.
      if (form.getAttribute('data-busy') === 'true') return;

      var idField = form.querySelector('[name="id"]');
      var qtyField = form.querySelector('[name="quantity"]');
      var variantId = idField ? parseInt(idField.value, 10) : NaN;
      var quantity = qtyField ? parseInt(qtyField.value, 10) : 1;
      if (!quantity || quantity < 1) quantity = 1;
      if (!variantId) { showToast('Please choose an option before adding to cart.', null, null, true); return; }

      var button = form.querySelector('[data-add-to-cart]');
      var original = button ? button.textContent : '';
      form.setAttribute('data-busy', 'true');
      if (button) { button.disabled = true; button.textContent = 'Adding…'; }

      var added;
      fetch(rootUrl('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
      })
        .then(function (res) {
          return res.json().then(function (json) { return { ok: res.ok, json: json }; });
        })
        .then(function (result) {
          if (!result.ok) throw new Error(result.json.description || result.json.message || 'This book could not be added to your cart.');
          added = result.json.items && result.json.items[0];
          return fetch(rootUrl('cart.js'), { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          // Only confirm once Shopify's cart really contains the book.
          var inCart = added && cart.items.some(function (item) { return item.variant_id === added.variant_id; });
          if (!inCart) throw new Error('This book could not be added to your cart. Please try again.');
          applyCartState(cart);
          document.dispatchEvent(new CustomEvent('cart:changed'));
          // The button is now replaced by [ − ] n [ + ]; keep keyboard focus on it.
          var plus = form.querySelector('[data-live-qty]:not([hidden]) [data-live-step="1"]');
          if (plus) plus.focus();
          var title = added.product_title || 'Book';
          showToast('✓ ' + (quantity > 1 ? quantity + ' × ' : '') + title + ' added to your cart (' + cart.item_count + ' in cart).', rootUrl('cart'), 'View Cart');
        })
        .catch(function (err) {
          // Shopify may still have added part of the quantity (e.g. "Only 10 items were added"), so resync.
          refreshCartState();
          showToast(err && err.message ? err.message : 'Something went wrong. Please check your connection and try again.', rootUrl('cart'), 'View Cart', true);
        })
        .then(function () {
          form.removeAttribute('data-busy');
          if (button) { button.disabled = false; button.textContent = original; }
        });
    });
  }

  /* ---------- In-place [ − ] n [ + ] on book cards and product pages ----------
     Once a book is in the cart its "Add to Cart" button is replaced by a quantity selector. Each click
     changes Shopify's cart immediately (/cart/change.js); reaching 0 removes the book and restores the button. */
  var lastCart = null;
  var liveBusy = {};

  function formVariant(form) {
    var field = form.querySelector('[name="id"]');
    return field ? parseInt(field.value, 10) : 0;
  }

  function applyCartState(cart) {
    lastCart = cart;
    var qty = {};
    cart.items.forEach(function (item) { qty[item.variant_id] = (qty[item.variant_id] || 0) + item.quantity; });
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var live = form.querySelector('[data-live-qty]');
      if (!live) return;
      var n = qty[formVariant(form)] || 0;
      var add = form.querySelector('[data-add-to-cart]');
      var pre = form.querySelector('[data-pre-add]');
      live.hidden = n === 0;
      if (add) add.hidden = n > 0;
      if (pre) pre.hidden = n > 0;
      live.querySelector('[data-live-qty-value]').textContent = n;
    });
    updateCartCount(cart.item_count);
  }

  function refreshCartState() {
    if (!window.fetch) return;
    fetch(rootUrl('cart.js'), { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(applyCartState)
      .catch(function () {});
  }

  function initLiveQty() {
    if (document.querySelector('[data-live-qty]')) refreshCartState();

    // Quick clicks are never lost: each click moves the wanted quantity at once, and the cart is
    // updated one request at a time until it matches what the customer last asked for.
    var wantedQty = {};

    function showWanted(id, n) {
      document.querySelectorAll('[data-product-form]').forEach(function (form) {
        if (formVariant(form) !== id) return;
        var value = form.querySelector('[data-live-qty-value]');
        if (value) value.textContent = n;
      });
    }

    function sendQty(id, form, title) {
      var target = wantedQty[id];
      liveBusy[id] = true;
      fetch(rootUrl('cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: String(id), quantity: target })
      })
        .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
        .then(function (result) {
          if (!result.ok) throw new Error(result.json.description || result.json.message || 'Could not update your cart. Please try again.');
          if (wantedQty[id] !== target) { sendQty(id, form, title); return; } // more clicks arrived meanwhile
          var cart = result.json;
          liveBusy[id] = false;
          delete wantedQty[id];
          applyCartState(cart);
          document.dispatchEvent(new CustomEvent('cart:changed'));
          var now = 0;
          cart.items.forEach(function (item) { if (item.variant_id === id) now += item.quantity; });
          if (target === 0) {
            showToast(title + ' removed from your cart.', rootUrl('cart'), 'View Cart');
            var add = form.querySelector('[data-add-to-cart]');
            if (add) add.focus();
          } else if (now < target) {
            showToast('Sorry, only ' + now + ' ' + (now === 1 ? 'copy is' : 'copies are') + ' available.', rootUrl('cart'), 'View Cart', true);
          } else {
            showToast(title + ': ' + now + ' in your cart (' + cart.item_count + ' ' + (cart.item_count === 1 ? 'book' : 'books') + ' in total).', rootUrl('cart'), 'View Cart');
          }
        })
        .catch(function (err) {
          liveBusy[id] = false;
          delete wantedQty[id];
          showToast(err && err.message ? err.message : 'Could not update your cart. Please check your connection.', rootUrl('cart'), 'View Cart', true);
          refreshCartState();
        });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-live-step]');
      if (!btn) return;
      var form = btn.closest('[data-product-form]');
      var live = btn.closest('[data-live-qty]');
      var id = form && formVariant(form);
      if (!id) return;
      var shown = parseInt(live.querySelector('[data-live-qty-value]').textContent, 10) || 0;
      var current = wantedQty[id] != null ? wantedQty[id] : shown;
      wantedQty[id] = Math.max(0, current + parseInt(btn.getAttribute('data-live-step'), 10));
      showWanted(id, wantedQty[id]);
      var title = (live.querySelector('[data-live-step="1"]').getAttribute('aria-label') || '').replace('Add one more copy of ', '');
      if (!liveBusy[id]) sendQty(id, form, title);
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQuantity() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus = wrap.querySelector('[data-qty-plus]');
      function step(delta) {
        var next = (parseInt(input.value, 10) || 1) + delta;
        input.value = Math.min(Math.max(next, 1), 99);
      }
      minus.addEventListener('click', function () { step(-1); });
      plus.addEventListener('click', function () { step(1); });
    });
  }

  /* ---------- Product gallery thumbnails ---------- */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (thumb, i) {
        if (i === 0) thumb.setAttribute('aria-current', 'true');
        thumb.addEventListener('click', function (e) {
          e.preventDefault();
          main.removeAttribute('srcset');
          main.src = thumb.getAttribute('data-src');
          main.alt = thumb.getAttribute('data-alt') || '';
          thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
          thumb.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* ---------- Variant select updates price / availability ---------- */
  function initVariantSelect() {
    document.querySelectorAll('[data-variant-select]').forEach(function (select) {
      var form = select.closest('form');
      var info = select.closest('.product__info');
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        var priceEl = info && info.querySelector('[data-product-price]');
        if (priceEl) {
          // Curated offer prices show the offer price plus the struck original price.
          var nowEl = priceEl.querySelector('[data-price-now]');
          var wasEl = priceEl.querySelector('[data-price-was]');
          if (nowEl && wasEl) {
            nowEl.textContent = opt.getAttribute('data-price');
            wasEl.lastChild.textContent = opt.getAttribute('data-compare');
          } else {
            priceEl.textContent = opt.getAttribute('data-price');
          }
        }
        var available = opt.getAttribute('data-available') === 'true';
        form.querySelectorAll('[data-add-to-cart], [data-buy-now]').forEach(function (b) { b.disabled = !available; });
        if (lastCart) applyCartState(lastCart);
      });
    });
  }

  /* ---------- Cart page: submit when a quantity changes ---------- */
  /* ---------- Cart page: steppers, Remove, quantity edits ----------
     Every change goes to Shopify's cart (/cart/change.js), which also returns this section re-rendered,
     so totals, discounts and the item count always come from the real cart. */
  function initCart() {
    var root = document.querySelector('[data-cart-root]');
    if (!root || !window.fetch) return;
    var sectionId = root.getAttribute('data-section-id');
    var busy = false;

    function setStatus(text) {
      var el = root.querySelector('[data-cart-status]');
      if (el) el.textContent = text;
    }
    function showError(text) {
      var el = root.querySelector('[data-cart-error]');
      if (!el) return;
      el.textContent = text || '';
      el.hidden = !text;
    }

    function change(key, quantity, message) {
      if (busy) return;
      busy = true;
      root.setAttribute('aria-busy', 'true');
      root.classList.add('is-updating');
      showError('');
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: sectionId })
      })
        .then(function (res) {
          return res.json().then(function (json) { return { ok: res.ok, json: json }; });
        })
        .then(function (result) {
          if (!result.ok) {
            // e.g. not enough stock: show Shopify's message and re-render the real cart.
            showError(result.json.description || result.json.message || 'Could not update your cart.');
            return refresh();
          }
          render(result.json.sections && result.json.sections[sectionId], result.json.item_count);
          setStatus(message || 'Cart updated.');
        })
        .catch(function () { showError('Could not update your cart. Please check your connection and try again.'); })
        .then(function () {
          busy = false;
          root.removeAttribute('aria-busy');
          root.classList.remove('is-updating');
        });
    }

    function refresh() {
      return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId))
        .then(function (res) { return res.json(); })
        .then(function (json) { render(json[sectionId]); });
    }

    function render(html, itemCount) {
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-root]');
        if (fresh) {
          var keepError = root.querySelector('[data-cart-error]');
          var errorText = keepError && !keepError.hidden ? keepError.textContent : '';
          root.innerHTML = fresh.innerHTML;
          if (errorText) showError(errorText);
          document.dispatchEvent(new CustomEvent('cart:rendered'));
        }
      }
      if (typeof itemCount === 'number') updateCartCount(itemCount);
      else fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { updateCartCount(c.item_count); });
    }

    // Books added from "Complete Your Set" (or their − / + changed): re-render so totals and suggestions stay true.
    document.addEventListener('cart:changed', function () { if (!busy) refresh(); });

    // "Clear cart": one confirmation, then Shopify empties the cart and the section re-renders (empty state).
    root.addEventListener('click', function (e) {
      var clear = e.target.closest('[data-cart-clear]');
      if (!clear) return;
      e.preventDefault();
      if (busy) return;
      var count = parseInt(clear.getAttribute('data-count'), 10) || 0;
      if (!window.confirm('Remove all ' + count + ' book' + (count === 1 ? '' : 's') + ' from your cart?')) return;
      busy = true;
      root.setAttribute('aria-busy', 'true');
      root.classList.add('is-updating');
      showError('');
      fetch(rootUrl('cart/clear.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ sections: sectionId })
      })
        .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
        .then(function (result) {
          if (!result.ok) throw new Error();
          if (result.json.sections && result.json.sections[sectionId]) render(result.json.sections[sectionId], 0);
          else return refresh();
        })
        .then(function () { setStatus('Your cart is now empty.'); })
        .catch(function () { showError('Could not clear your cart. Please try again.'); refresh(); })
        .then(function () {
          busy = false;
          root.removeAttribute('aria-busy');
          root.classList.remove('is-updating');
        });
    });

    root.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-cart-remove]');
      var step = e.target.closest('[data-cart-step]');
      if (!remove && !step) return;
      var line = e.target.closest('[data-cart-line]');
      if (!line) return;
      e.preventDefault();
      var key = line.getAttribute('data-key');
      var title = line.getAttribute('data-title');
      if (remove) { change(key, 0, title + ' removed from your cart.'); return; }
      var input = line.querySelector('[data-cart-qty]');
      var current = parseInt(input.value, 10) || 1;
      var next = current + parseInt(step.getAttribute('data-cart-step'), 10);
      if (next < 1) return; // the stepper stops at 1; use Remove to delete a book
      input.value = next;
      change(key, next, title + ': quantity ' + next + '.');
    });

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      var line = input.closest('[data-cart-line]');
      var qty = parseInt(input.value, 10);
      if (!(qty >= 1)) qty = 1; // 0, blank or invalid: keep the book; Remove deletes it
      input.value = qty;
      change(line.getAttribute('data-key'), qty, line.getAttribute('data-title') + ': quantity ' + qty + '.');
    });

    // Enter in a quantity box updates that line instead of submitting the whole form.
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-cart-qty]')) { e.preventDefault(); e.target.blur(); }
    });
  }

  /* ---------- Sort select ---------- */
  function initAutoSubmit() {
    document.querySelectorAll('[data-auto-submit]').forEach(function (select) {
      select.addEventListener('change', function () { select.form.submit(); });
    });
  }

  /* ---------- Close mobile panels when navigating or pressing Escape ---------- */
  function initDetailsPanels() {
    var panels = document.querySelectorAll('[data-mobile-menu], [data-mobile-search]');
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      panels.forEach(function (p) { p.removeAttribute('open'); });
    });
    document.addEventListener('click', function (e) {
      panels.forEach(function (p) { if (p.hasAttribute('open') && !p.contains(e.target)) p.removeAttribute('open'); });
    });
    panels.forEach(function (p) {
      p.addEventListener('toggle', function () {
        if (!p.open) return;
        panels.forEach(function (other) { if (other !== p) other.removeAttribute('open'); });
        var field = p.querySelector('input');
        if (field) field.focus();
      });
    });
  }

  /* ---------- Header dropdowns (Exam Collections): hover/focus in CSS, chevron button for touch, Esc to close ---------- */
  function initNavDrops() {
    var drops = document.querySelectorAll('[data-nav-drop]');
    if (!drops.length) return;
    function setOpen(drop, open) {
      drop.classList.toggle('is-open', open);
      drop.classList.toggle('is-closed', !open && drop.matches(':hover, :focus-within'));
      var btn = drop.querySelector('[data-nav-drop-toggle]');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    drops.forEach(function (drop) {
      drop.querySelector('[data-nav-drop-toggle]').addEventListener('click', function (e) {
        e.preventDefault();
        var open = !drop.classList.contains('is-open');
        drops.forEach(function (d) { if (d !== drop) setOpen(d, false); });
        setOpen(drop, open);
      });
      drop.addEventListener('mouseleave', function () { drop.classList.remove('is-closed'); });
      drop.addEventListener('focusout', function (e) {
        if (!drop.contains(e.relatedTarget)) { drop.classList.remove('is-open', 'is-closed'); drop.querySelector('[data-nav-drop-toggle]').setAttribute('aria-expanded', 'false'); }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      drops.forEach(function (d) {
        if (!d.classList.contains('is-open') && !d.matches(':hover, :focus-within')) return;
        setOpen(d, false);
        if (d.contains(document.activeElement)) d.querySelector('[data-nav-drop-toggle]').focus();
      });
    });
    document.addEventListener('click', function (e) {
      drops.forEach(function (d) { if (d.classList.contains('is-open') && !d.contains(e.target)) setOpen(d, false); });
    });
  }

  /* ---------- Scrolling book rows (Curated Collection) ---------- */
  function initRails() {
    document.querySelectorAll('[data-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-rail-track]');
      var prev = rail.querySelector('[data-rail-prev]');
      var next = rail.querySelector('[data-rail-next]');
      if (!track || !prev || !next) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
        // Hide the arrows when every card already fits on screen.
        rail.classList.toggle('is-static', max <= 0);
      }
      function go(dir) { track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.8, 240), behavior: 'smooth' }); }
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Help Desk form (Shopify contact form) ---------- */
  function initHelpDesk() {
    var done = document.querySelector('[data-help-desk-done]');
    if (done) { done.focus(); return; }
    var errors = document.querySelector('[data-help-desk-errors]');
    if (errors) errors.scrollIntoView({ block: 'center' });
    var form = document.querySelector('[data-help-desk-form]');
    if (!form) return;
    var button = form.querySelector('[data-help-desk-submit]');
    var checks = {
      'hd-email': function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); },
      'hd-phone': function (v) { return /^(\+?91|0)?[6-9]\d{9}$/.test(v.replace(/[\s-]/g, '')); },
      'hd-issue': function (v) { return v.length >= 10; }
    };
    function check(id) {
      var input = document.getElementById(id);
      var ok = checks[id](input.value.trim());
      var msg = document.getElementById(id + '-error');
      input.setAttribute('aria-invalid', ok ? 'false' : 'true');
      if (msg) msg.hidden = ok;
      return ok;
    }
    Object.keys(checks).forEach(function (id) {
      var input = document.getElementById(id);
      input.addEventListener('blur', function () { if (input.value.trim()) check(id); });
      input.addEventListener('input', function () { if (input.getAttribute('aria-invalid') === 'true') check(id); });
    });
    form.addEventListener('submit', function (e) {
      var firstBad = null;
      Object.keys(checks).forEach(function (id) { if (!check(id) && !firstBad) firstBad = document.getElementById(id); });
      if (firstBad) { e.preventDefault(); firstBad.focus(); return; }
      // Block extra clicks without disabling the button: Shopify's spam check (hCaptcha) may hold the
      // first submit and re-submit through this button, which a disabled button would prevent.
      button.textContent = 'Sending…';
      button.classList.add('is-busy');
      button.setAttribute('aria-busy', 'true');
    });
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && button.classList.contains('is-busy') && e.target.tagName !== 'TEXTAREA') e.preventDefault();
    });
  }

  /* ---------- Cart: PIN code delivery check (Shopify's own shipping rates) ---------- */
  // Delegated, so it keeps working after the cart section re-renders.
  function initPinCheck() {
    function provinces() {
      var countries = document.querySelector('[data-pin-countries]');
      if (!countries) return [];
      var india = Array.prototype.slice.call(countries.options).filter(function (o) { return o.value === 'India'; })[0];
      try { return JSON.parse(india.getAttribute('data-provinces') || '[]'); } catch (e) { return []; }
    }
    function fillStates() {
      var select = document.querySelector('[data-pin-state]');
      if (!select || select.options.length > 1) return;
      provinces().forEach(function (p) { var o = document.createElement('option'); o.value = p[0]; o.textContent = p[1]; select.appendChild(o); });
      try { var saved = JSON.parse(localStorage.getItem('ncw-pin') || 'null'); if (saved) { select.value = saved.state; document.querySelector('[data-pin]').value = saved.pin; } } catch (e) {}
    }
    function show(text, ok) {
      var out = document.querySelector('[data-pin-result]');
      out.textContent = text;
      out.className = 'pincheck__result ' + (ok ? 'pincheck__result--ok' : 'pincheck__result--err');
    }
    fillStates();
    document.addEventListener('cart:rendered', fillStates);
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-pin-check]')) return;
      var pin = (document.querySelector('[data-pin]').value || '').replace(/\D/g, '');
      var state = document.querySelector('[data-pin-state]').value;
      if (!/^[1-9][0-9]{5}$/.test(pin)) { show('Please enter a valid 6-digit PIN code.', false); return; }
      if (!state) { show('Please choose your state.', false); return; }
      show('Checking…', true);
      var q = 'shipping_address[country]=IN&shipping_address[province]=' + encodeURIComponent(state) + '&shipping_address[zip]=' + pin;
      fetch(rootUrl('cart/shipping_rates.json') + '?' + q, { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
        .then(function (r) {
          if (!r.ok) {
            var msg = r.json && (r.json.zip || r.json.province || r.json.country);
            show((msg && msg[0]) ? msg[0] + '.' : 'We could not check this PIN code. Please confirm your address at checkout.', false);
            return;
          }
          var rates = (r.json.shipping_rates || []);
          if (!rates.length) { show('Sorry, we do not currently deliver to this PIN code.', false); return; }
          var cheapest = rates.reduce(function (a, b) { return parseFloat(a.price) <= parseFloat(b.price) ? a : b; });
          var price = parseFloat(cheapest.price);
          show('✓ We ship to ' + pin + '. Shipping: ' + (price ? '₹' + Math.round(price).toLocaleString('en-IN') : 'Free') + ' (' + cheapest.name + '), confirmed at checkout.', true);
          try { localStorage.setItem('ncw-pin', JSON.stringify({ pin: pin, state: state })); } catch (e) {}
        })
        .catch(function () { show('We could not check this PIN code right now. Please confirm your address at checkout.', false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-pin]')) {
        e.preventDefault();
        var b = document.querySelector('[data-pin-check]'); if (b) b.click();
      }
    });
  }

  /* ---------- Header search panel with live suggestions (Shopify predictive search) ---------- */
  function initSearch() {
    var panel = document.querySelector('[data-search-panel]');
    var openBtn = document.querySelector('[data-search-open]');
    if (!panel || !openBtn) return;
    var input = panel.querySelector('[data-search-input]');
    var results = panel.querySelector('[data-search-results]');
    var closeBtn = panel.querySelector('[data-search-close]');
    var timer = null;
    var latest = 0;

    function open() {
      panel.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      setTimeout(function () { input.focus(); if (input.value) input.select(); }, 30);
      if (input.value.trim().length >= 2) suggest();
    }
    function close(returnFocus) {
      panel.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      if (returnFocus) openBtn.focus();
    }
    function suggest() {
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      var ticket = ++latest;
      if (!results.innerHTML) results.innerHTML = '<p class="search-results__loading">Searching…</p>';
      var url = rootUrl('search/suggest') + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,tag&section_id=predictive-search';
      fetch(url)
        .then(function (res) { if (!res.ok) throw new Error(); return res.text(); })
        .then(function (html) {
          if (ticket !== latest) return; // a newer search is already on its way
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('.shopify-section') || doc.body;
          results.innerHTML = section.innerHTML;
        })
        .catch(function () {
          if (ticket !== latest) return;
          results.innerHTML = '<div class="search-results__empty"><p>Suggestions are unavailable right now.</p><p class="muted small">Press Search to see all matching books.</p></div>';
        });
    }

    openBtn.addEventListener('click', function () { if (panel.hidden) open(); else close(false); });
    closeBtn.addEventListener('click', function () { close(true); });
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(suggest, 220); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(true); });
    document.addEventListener('click', function (e) {
      if (panel.hidden) return;
      if (panel.contains(e.target) || openBtn.contains(e.target)) return;
      close(false);
    });
    // Arrow-down from the field moves into the suggestions for keyboard users.
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown') return;
      var first = results.querySelector('a');
      if (first) { e.preventDefault(); first.focus(); }
    });
    results.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var links = Array.prototype.slice.call(results.querySelectorAll('a'));
      var i = links.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      if (e.key === 'ArrowDown' && links[i + 1]) links[i + 1].focus();
      if (e.key === 'ArrowUp') (links[i - 1] || input).focus();
    });
  }

  /* ---------- Exam book lists: tick books, add them to the cart together ---------- */
  function initExamSelect() {
    var bar = document.querySelector('[data-exam-selbar]');
    if (!bar) return;
    var picks = Array.prototype.slice.call(document.querySelectorAll('[data-exam-pick]'));
    var summary = bar.querySelector('[data-exam-summary]');
    var addBtn = bar.querySelector('[data-exam-add]');
    var clearBtn = bar.querySelector('[data-exam-clear]');
    var symbol = bar.getAttribute('data-currency') || '₹';
    var busy = false;

    function chosen() { return picks.filter(function (p) { return p.checked && !p.disabled; }); }
    // Whole rupees for display (same rule as snippets/price); the cart itself keeps exact amounts.
    function money(paise) { return symbol + Math.round(paise / 100).toLocaleString('en-IN'); }
    function update() {
      var list = chosen();
      var total = list.reduce(function (sum, p) { return sum + (parseInt(p.getAttribute('data-price'), 10) || 0); }, 0);
      summary.innerHTML = list.length
        ? '<strong>' + list.length + '</strong> book' + (list.length === 1 ? '' : 's') + ' selected · <strong>' + money(total) + '</strong>'
        : 'Tick the books you need, then add them together.';
      addBtn.disabled = busy || !list.length;
      clearBtn.disabled = !list.length;
    }

    picks.forEach(function (p) { p.addEventListener('change', update); });
    document.querySelectorAll('[data-exam-group-all]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = document.getElementById(btn.getAttribute('data-exam-group-all'));
        var boxes = Array.prototype.slice.call(group.querySelectorAll('[data-exam-pick]:not(:disabled)'));
        var allOn = boxes.length && boxes.every(function (b) { return b.checked; });
        boxes.forEach(function (b) { b.checked = !allOn; });
        btn.textContent = allOn ? 'Select all' : 'Clear all';
        update();
      });
    });
    clearBtn.addEventListener('click', function () {
      picks.forEach(function (p) { p.checked = false; });
      document.querySelectorAll('[data-exam-group-all]').forEach(function (b) { b.textContent = 'Select all'; });
      update();
    });
    addBtn.addEventListener('click', function () {
      var list = chosen();
      if (!list.length || busy) return;
      busy = true;
      addBtn.textContent = 'Adding…';
      update();
      fetch(rootUrl('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: list.map(function (p) { return { id: parseInt(p.getAttribute('data-variant'), 10), quantity: 1 }; }) })
      })
        .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
        .then(function (result) {
          if (!result.ok) throw new Error(result.json.description || result.json.message || 'These books could not be added to your cart.');
          return fetch(rootUrl('cart.js'), { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          applyCartState(cart);
          picks.forEach(function (p) { p.checked = false; });
          document.querySelectorAll('[data-exam-group-all]').forEach(function (b) { b.textContent = 'Select all'; });
          showToast('✓ ' + list.length + ' book' + (list.length === 1 ? '' : 's') + ' added to your cart (' + cart.item_count + ' in cart).', rootUrl('cart'), 'View Cart');
        })
        .catch(function (err) {
          refreshCartState();
          showToast(err && err.message ? err.message : 'Could not add the books. Please try again.', rootUrl('cart'), 'View Cart', true);
        })
        .then(function () {
          busy = false;
          addBtn.textContent = 'Add selected to cart';
          update();
        });
    });
    update();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSearch();
    initNavDrops();
    initPinCheck();
    initExamSelect();
    initHelpDesk();
    initRails();
    initLiveQty();
    initProductForms();
    initQuantity();
    initGallery();
    initVariantSelect();
    initCart();
    initAutoSubmit();
    initDetailsPanels();
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    // A page restored from the back/forward cache may show an old cart; Shopify's cart is the source of truth,
    // so reload the cart page and resync counts and quantity selectors elsewhere.
    if (document.querySelector('[data-cart-root]')) window.location.reload();
    else refreshCartState();
  });
})();
